module.exports = __webpack_public_path__ + "static/img/5284_phase_function_Paper_Points.7b56797.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5284_phase_function_Paper_Points.png
// module id = S4LL
// module chunks = 0